import { common_CLEAR_DATA } from '../actions/common'
import type { TReduxAction } from '../actions'
import { planner_SET_VIEW_SCHEDULE_SEARCH } from '../actions/planner'

export type TPlannerState = {
    viewScheduleSearchText: string
}

const initialState = {
    viewScheduleSearchText: '',
}

export function plannerReducer(state: TPlannerState = initialState, action: TReduxAction): TPlannerState {
    switch (action.type) {
        case planner_SET_VIEW_SCHEDULE_SEARCH:
            return {
                ...state,
                viewScheduleSearchText: action.searchText,
            }
        case common_CLEAR_DATA:
            return initialState
        default:
            return state
    }
}
